import { useTranslation } from 'react-i18next';
import { useActiveConversation } from '../../contexts/ActiveConversationContext';
import { useConversations } from '../../contexts/ConversationsContext';
import { useMobileDrawer } from '../../contexts/MobileDrawerContext';
import { useTheme } from '../../contexts/ThemeContext';
import {
  IconChevronLeft,
  IconChevronRight,
  IconHamburger,
} from '../primitives/Icons';

const THEME_ICONS: Record<string, string> = {
  morning: '🌅',
  afternoon: '☀️',
  evening: '🌙',
};

const THEME_LABEL_KEYS: Record<string, string> = {
  morning: 'themeBadgeMorning',
  afternoon: 'themeBadgeAfternoon',
  evening: 'themeBadgeEvening',
};

export function ChatHeader() {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const { conversationId } = useActiveConversation();
  const { conversations } = useConversations();
  const { open, desktopCollapsed, toggleDesktopCollapsed } = useMobileDrawer();

  const conv = conversations.find((c) => c.id === conversationId);
  const title = conv?.title || t('untitled');

  return (
    <div className="chat-header">
      <div className="chat-header-left">
        {/* Mobile: hamburger opens the drawer. */}
        <button
          type="button"
          className="collapse-btn mobile-only"
          onClick={open}
          title={t('newChat')}
          aria-label={t('newChat')}
        >
          <IconHamburger />
        </button>
        {/* Desktop: chevron toggles collapsed sidebar. */}
        <button
          type="button"
          className="collapse-btn collapse-btn-desktop"
          onClick={toggleDesktopCollapsed}
          title={desktopCollapsed ? t('expandSidebar') : t('collapseSidebar')}
          aria-label={desktopCollapsed ? t('expandSidebar') : t('collapseSidebar')}
        >
          {desktopCollapsed ? <IconChevronRight /> : <IconChevronLeft />}
        </button>
        <span className="chat-header-title">{conversationId ? title : t('newChat')}</span>
      </div>
      <div className="chat-header-right">
        <div className="theme-badge">
          <span className="theme-dot" />
          <span>
            {THEME_ICONS[theme]} {t(THEME_LABEL_KEYS[theme] ?? '')}
          </span>
        </div>
      </div>
    </div>
  );
}
